// extracted by mini-css-extract-plugin
export default {"menu":"Menu_menu__uIEoR","open":"Menu_open__wE18i","navLinks":"Menu_navLinks__cv4qA","overlay":"Menu_overlay__dlFPv","showOverlay":"Menu_showOverlay__a7CY1"};